export function highlightSearchValueInText(text?: string, searchValue?: string) {
    if (!text) return ''
    if (!searchValue) return text;
  
    const escapeRegExpSymbols = (v: string) =>
      v.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
  
    // Разбиваем строку запроса на отдельные слова
    const words = searchValue
      .toLowerCase()
      .split(/\s+/)
      .filter(Boolean)
      .map(escapeRegExpSymbols);
  
    // Если нечего подсвечивать — возвращаем как есть
    if (words.length === 0) return text;
  
    const regex = new RegExp(`(${words.join('|')})`, 'gi');
    const parts = text.split(regex);
  
    return (
      <span>
        {parts.filter(Boolean).map((part, i) =>
          regex.test(part) ? (
            <mark key={i}>{part}</mark>
          ) : (
            <span key={i}>{part}</span>
          )
        )}
      </span>
    );
  }